import React from "react";

class GameOverModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        let title = "";
        let description = "";

        if (this.props.victory) {
            title = "Victory!"
            description = "You successfully matched all tiles!"
        } else {
            title = "Game over!"
            description = "You did not successfully match all tiles."
        }

        return (
            <div id="modal-game-over" className="modal-bg display-none" data-modalid="modal-game-over" onClick={this.props.closeButton}>
                <div className="modal-container modal-game-over" onClick={this.props.stopPropagation}>
                    <div className="modal-content">
                        <h2>{title}</h2>
                        <p>
                            {description}
                        </p>
                        <br />
                        <button className="button" onClick={this.props.newGame}>New game!</button>
                        <br />
                    </div>
                </div>
            </div>
        );
    }
}

export default GameOverModal;